import { atom } from "recoil";

export const taskStatsAtom = atom({
  key: "taskStatsAtom",
  default: {
    tasks: {
      open: 0,
    },
  },
});
